import {
    Box,
    styled
} from '@mui/material';

import LoginIcon from '../../icons/login.svg';
import React from 'react';

const KeyWrapper = styled(Box)(
    ({ theme }) => `
        color: ${theme.palette.text.primary}; 
        position: absolute;  
        left: 0px;
        bottom: 0px;
        @media only screen and (max-width: 1280px) {
            display:none
          };
`
);

function LoginWithKey() {
    return (
        <KeyWrapper>
            <Box
                component="img"
                sx={{
                    width: '90%',
                    '@media only screen and (max-width: 1640px)': {
                        width: '70%'
                    },
                }}
                src={LoginIcon} alt='LoginIcon' />
        </KeyWrapper>
    );
}

export default LoginWithKey;
